export default __webpack_public_path__ + "static/media/default_routes_user.0db2efaf.svg";